module.exports = __webpack_public_path__ + "static/media/woman_sized.dab810fa.jpg";